<app-section-quick-actions section="realm" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Eden Statue Tracker</h1>
</header>

<div class="atmos-pnr-tracker__container">
  <div class="atmos-pnr-tracker__controls">
    <button type="button" class="atmos-btn atmos-btn--sm" [skyTooltip]="'Help'" placement="bottom-start" (click)="showHelp()">
      <mat-icon>question_mark</mat-icon>
    </button>
    <button type="button"
      class="atmos-btn atmos-btn--sm"
      [class.atmos-btn--active]="isNavigationEnabled()"
      [skyTooltip]="'Navigate'" placement="bottom-start"
      (click)="toggleNavigation()">
      <mat-icon>navigation</mat-icon>
    </button>
    <button type="button" class="atmos-btn atmos-btn--sm" [skyTooltip]="'Restart'" placement="bottom-start" (click)="promptReset()">
      <mat-icon>restart_alt</mat-icon>
    </button>
    <span class="atmos-pnr-tracker__count" [class.is-complete]="countFound() === countTotal">
      {{ countFound() }} / {{ countTotal }}
    </span>
  </div>
  <div #map id="atmos-pnr-map" class="atmos-pnr-tracker__map"></div>
</div>
